"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVariationAttributes = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _useVariationParams = require("./use-variation-params");
var _url = require("../utils/url");
var _usePdpSearchParams = require("./use-pdp-search-params");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */ // Other Hooks
// Utils
/**
 * Return the first image in the `swatch` type image group for a given
 * variation value of a product.
 *
 * @param {Object} product
 * @param {Object} variationValue
 * @returns {Object} image
 */
const getVariantValueSwatch = (product, variationValue) => {
  var _imageGroup$images;
  const {
    imageGroups = []
  } = product;
  const imageGroup = imageGroups.filter(({
    viewType
  }) => viewType === 'swatch').find(({
    variationAttributes = []
  }) => {
    const colorAttribute = variationAttributes.find(({
      id
    }) => id === 'color');
    // @ts-ignore
    const colorValues = (colorAttribute === null || colorAttribute === void 0 ? void 0 : colorAttribute.values) || [];

    // A single image can represent multiple variation values, so we only need
    // ensure the variation values appears in once of the images represented values.
    // @ts-ignore
    return colorValues.some(
    // @ts-ignore
    ({
      value
    }) => value === variationValue.value);
  });
  return imageGroup === null || imageGroup === void 0 ? void 0 : (_imageGroup$images = imageGroup.images) === null || _imageGroup$images === void 0 ? void 0 : _imageGroup$images[0];
};

/**
 * Build a product href
 *
 * @param {Object} product
 * @param {Object} params
 * @param {Object} location
 * @returns {String} a product url for the current variation value.
 */
const buildVariantValueHref = ({
  pathname,
  existingParams,
  newParams,
  productId,
  isProductPartOfSet
}) => {
  const [allParams, productParams] = existingParams;
  if (isProductPartOfSet) {
    (0, _url.updateSearchParams)(productParams, newParams);
    allParams.set(productId, productParams.toString());
  } else {
    (0, _url.updateSearchParams)(allParams, newParams);
  }
  return `${pathname}?${allParams.toString()}`;
};

/**
 * Determine if a products variant attribute value is orderable without having to
 * load the variant in question, but filtering the list of variants with the
 * passed in attribute values.
 *
 * @param {Object} product
 * @param {Object} variationParams
 * @returns
 */
const isVariantValueOrderable = (product, variationParams) => {
  return product.variants.filter(({
    variationValues
  }) => Object.keys(variationParams).every(key => variationValues[key] === variationParams[key])).some(({
    orderable
  }) => orderable);
};

/**
 * Use a decorated version of a product variation attributes. This version
 * will have the following additions: which variation attribute is selected,
 * each value will have a product url, the swatch image if there is one, and
 * an updated orderable flag.
 *
 * @param {Object} product
 * @returns {Array} a decorated variation attributes list.
 *
 */
const useVariationAttributes = (product = {}, isProductPartOfSet = false) => {
  const {
    variationAttributes = []
  } = product;
  const location = (0, _reactRouterDom.useLocation)();
  const variationParams = (0, _useVariationParams.useVariationParams)(product, isProductPartOfSet);
  // @ts-ignore
  const existingParams = (0, _usePdpSearchParams.usePDPSearchParams)(product.id);
  return (0, _react.useMemo)(() => variationAttributes.map(variationAttribute => {
    var _variationAttribute$v;
    return _objectSpread(_objectSpread({}, variationAttribute), {}, {
      selectedValue: {
        name: (_variationAttribute$v = variationAttribute.values.find(({
          value
        }) => value === (variationParams === null || variationParams === void 0 ? void 0 : variationParams[variationAttribute.id]))) === null || _variationAttribute$v === void 0 ? void 0 : _variationAttribute$v.name,
        value: variationParams === null || variationParams === void 0 ? void 0 : variationParams[variationAttribute.id]
      },
      values: variationAttribute.values.map(value => {
        const params = _objectSpread(_objectSpread({}, variationParams), {}, {
          [variationAttribute.id]: value.value
        });
        return _objectSpread(_objectSpread({}, value), {}, {
          image: getVariantValueSwatch(product, value),
          href: buildVariantValueHref({
            pathname: location.pathname,
            existingParams,
            newParams: params,
            // @ts-ignore
            productId: product.id,
            isProductPartOfSet
          }),
          orderable: isVariantValueOrderable(product, params)
        });
      })
    });
  }), [location.search, product]);
};
exports.useVariationAttributes = useVariationAttributes;